import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

// sibling to the #root element on the actual html dom
const modalRoot = document.getElementById('modal-portal');

class ModalPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

ModalPortal.propTypes = {
  children: PropTypes.node,
};

export {
  ModalPortal,
};
